const offerStorage={
 get(key){try{return sessionStorage.getItem(key)}catch{return null}},
 set(key,value){try{sessionStorage.setItem(key,value)}catch{}}
};
const offerDuration=20*60*1000;
let offerDeadline=Number(offerStorage.get('merryvinyls-merry20-offer-deadline-v6'));
if(!Number.isFinite(offerDeadline)||offerDeadline<1){offerDeadline=Date.now()+offerDuration;offerStorage.set('merryvinyls-merry20-offer-deadline-v6',String(offerDeadline))}
const offerBar=document.querySelector('.top-offer');
offerBar.innerHTML='<button class="offer-trigger" type="button" id="offer-open"><span>✦ EXTRA 20% AT CHECKOUT</span><strong>View your code</strong><span class="offer-time-boxes" role="timer" aria-label="Offer preview session countdown"><span><b id="offer-minutes">20</b><small>mins</small></span><i>:</i><span><b id="offer-seconds">00</b><small>secs</small></span></span></button>'; 
const defaultOfferBarHTML=offerBar.innerHTML;
const offerOverlay=document.createElement('div');
offerOverlay.className='offer-overlay';offerOverlay.hidden=true;
offerOverlay.innerHTML=`<div class="offer-modal" role="dialog" aria-modal="true" aria-labelledby="offer-heading" aria-describedby="offer-description">
  <div class="offer-confetti" aria-hidden="true"></div>
  <button class="offer-close" type="button" aria-label="Close offer">×</button>
  <div class="offer-gift" aria-hidden="true"><svg viewBox="0 0 32 32"><path d="M5 15h10v13H5zm12 0h10v13H17zM3 9h12v4H3zm14 0h12v4H17z"/><path d="M16 9C6 9 6 2.5 10 3c3 .3 6 6 6 6Zm0 0c10 0 10-6.5 6-6-3 .3-6 6-6 6Z" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>
  <span class="offer-kicker">A LITTLE CHRISTMAS EXTRA</span>
  <h2 id="offer-heading">Your extra <em>20% off</em> is ready.</h2>
  <p id="offer-description">Use MERRY20 for 20% off your player. Optional extras keep their displayed prices.</p>
  <div class="offer-ticket"><button class="offer-copy" type="button" id="offer-copy" aria-label="Copy discount code MERRY20"><small>YOUR CODE</small><strong>MERRY20 <svg class="offer-copy-icon" viewBox="0 0 24 24" aria-hidden="true"><rect x="8" y="8" width="12" height="13" rx="2"/><path d="M16 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h3"/></svg></strong><span class="offer-copy-hint">Copy code</span><span class="offer-copy-status" role="status" aria-live="polite"></span></button><div class="offer-ticket-time"><small>OFFER TIMER</small><time id="offer-modal-time">20:00</time></div></div>
  <button class="offer-claim" type="button" id="offer-claim">GOT IT. USE AT CHECKOUT <span aria-hidden="true">→</span></button>
  <p class="offer-fineprint">The timer shows this visit’s offer window. Shopify confirms discount eligibility at checkout.</p>
</div>`;
document.body.append(offerOverlay);
const offerOpen=document.querySelector('#offer-open'),offerClose=offerOverlay.querySelector('.offer-close'),offerClaim=offerOverlay.querySelector('#offer-claim'),offerCopy=offerOverlay.querySelector('#offer-copy');
const bundleTimes=[...document.querySelectorAll('[data-bundle-time]')];
const bundleOffers=[...document.querySelectorAll('[data-bundle-offer]')];
const bundlePrices=[...document.querySelectorAll('[data-bundle-price]')];
const headlinePrice=document.querySelector('#display-price'),promoCodeBadge=document.querySelector('#promo-code-badge'),returnDiscountBadge=document.querySelector('#return-discount-badge');
const checkoutButton=document.querySelector('#checkout-button');
const checkoutOfferNotes=[...document.querySelectorAll('#checkout-offer-note')];
let offerPreviousFocus=null;
const autoDiscountKey='merryvinyls-merry20-auto-discount-applied-v1';
const returnDiscountCode='MVRETURN5';
const returnBaseDiscountCode='MERRY20';
const legacyOfferDiscountCodes=[];
const bundleDiscountCodes={normal:{},return:{},regular:{}};
const allBundleDiscountCodes=['MVRETURN5','MVRETURN13','MVRETURN20','MV2SET11999V1','MV3SET17499V1'];
const sourceBundleDiscountCodes={};
function bundleCartQuantity(cart){return (cart?.items||[]).filter(item=>window.LUMY_IS_MAIN_VARIANT?.(item.variant_id)).reduce((sum,item)=>sum+Number(item.quantity||0),0)}
function bundleCodeForCart(cart){
 const quantity=bundleCartQuantity(cart);if(!quantity)return '';
 const manualNormal=(cart?.discount_codes||[]).some(item=>String(item.code||'').toUpperCase()==='MERRY20')&&offerStorage.get(autoDiscountKey)!==String(offerDeadline);
 const returned=returnOfferIsActive();
 const codes=normalOfferIsActive()||manualNormal?[quantity>=3?'MV3SET17499V1':quantity===2?'MV2SET11999V1':'MERRY20']:[];
 if(returned)codes.push('MVRETURN5');
 return codes.join(',');
}
let cartOfferApplying=false;
let cartOfferPromise=null;
let discountCleanupPromise=null,lastDiscountCleanupAt=0;
function returnOfferIsActive(){
 return offerStorage.get('merryvinyls-merry20-return-offer-fired-v6')==='1'&&Number(offerStorage.get('merryvinyls-merry20-return-offer-deadline-v6'))>Date.now();
}
function normalOfferIsActive(){
 return offerStorage.get('merryvinyls-merry20-return-offer-fired-v6')==='1'?returnOfferIsActive():Date.now()<offerDeadline;
}
function markCheckoutDeparture(){
 offerStorage.set('merryvinyls-merry20-return-checkout-started-v6',String(Date.now()));
}
async function clearExpiredAutoDiscount(){
 if(normalOfferIsActive()||returnOfferIsActive())return;
 if(Date.now()-lastDiscountCleanupAt<30000)return;
 lastDiscountCleanupAt=Date.now();
 await synchronizeOfferCart();
}
function roundUp99Cents(cents){
 return window.LUMY_MONEY?.precision?window.LUMY_MONEY.precision(Math.round(Number(cents)||0)):Math.round(Number(cents)||0);
}
async function redirectWithReturnDiscount(cart,root){
 const updated=await synchronizeOfferCart(cart);
 if(!updated)throw new Error('could not apply the checkout price');
 markCheckoutDeparture();
 window.location.assign(root+'checkout');
}
// Keep the displayed estimate at the same price and currency precision Shopify charges.
function bundleExtraCents(quantity){
 return window.LUMY_MONEY.fromUSD(quantity>=3?1998:quantity===2?999:0);
}
function bundlePreviewCents(quantity,active){
 const variants=window.LUMY_SELECTED_VARIANTS?.(quantity)||Array.from({length:quantity},()=>({price:Number(window.LUMY_PRICE_CENTS||0)}));
 const base=variants.reduce((sum,v)=>sum+Number(v.price),0);
 if(!active)return roundUp99Cents(base);
 return Math.max(0,roundUp99Cents(base-(quantity>=3?window.LUMY_MONEY.fromUSD(6870):quantity===2?window.LUMY_MONEY.fromUSD(4247):Math.floor(base/5))));
}
window.MV_BUNDLE_PREVIEW=bundlePreviewCents;
function bundleListPriceCents(quantity){
 const variants=window.LUMY_SELECTED_VARIANTS?.(quantity)||Array.from({length:quantity},()=>({price:Number(window.LUMY_PRICE_CENTS||0)}));
 return variants.reduce((sum,v)=>sum+roundUp99Cents(Number(v.compare||v.price)),0);
}
function offerTime(){
 const seconds=Math.max(0,Math.ceil((offerDeadline-Date.now())/1000));
 offerBar.style.setProperty('--offer-progress',(Math.min(1,Math.max(0,1-(offerDeadline-Date.now())/offerDuration))*100).toFixed(2)+'%');
 offerBar.classList.toggle('offer-session-ended',seconds===0);
 const returnDeadline=Number(offerStorage.get('merryvinyls-merry20-return-offer-deadline-v6'))||0;
 const returnActive=returnOfferIsActive();
 const baseActive=normalOfferIsActive();
 const returnStage=offerStorage.get('merryvinyls-merry20-return-offer-fired-v6')==='1';
 const shownSeconds=returnStage?Math.max(0,Math.ceil((returnDeadline-Date.now())/1000)):seconds;
 const mm=String(Math.floor(shownSeconds/60)).padStart(2,'0');
 const ss=String(shownSeconds%60).padStart(2,'0');
 const display=`${mm}:${ss}`;
 window.LUMY_OFFER_STATE={seconds:shownSeconds,active:baseActive||returnActive,returnActive,deadline:returnStage?returnDeadline:offerDeadline,duration:returnStage?10*60*1000:offerDuration,extra:returnActive?window.LUMY_MONEY.format(window.LUMY_MONEY.fromUSD(500)):''};
 window.LUMY_RENDER_CART_OFFER?.(window.LUMY_OFFER_STATE);
 const minutesNode=document.querySelector('#offer-minutes'),secondsNode=document.querySelector('#offer-seconds'),modalTimeNode=document.querySelector('#offer-modal-time');
 if(minutesNode)minutesNode.textContent=String(Math.floor(seconds/60)).padStart(2,'0');
 if(secondsNode)secondsNode.textContent=String(seconds%60).padStart(2,'0');
 if(modalTimeNode)modalTimeNode.textContent=String(Math.floor(seconds/60)).padStart(2,'0')+':'+String(seconds%60).padStart(2,'0');
 bundleTimes.forEach(el=>el.textContent=display);
 bundleOffers.forEach(el=>el.classList.toggle('is-expired',shownSeconds===0));
 bundlePrices.forEach(el=>{
  const quantity=Number(el.closest('.bundle')?.querySelector('[name=bundle]')?.value||1);
  const regular=bundlePreviewCents(quantity,false);
  const sale=bundlePreviewCents(quantity,true);
  const returnSale=Math.max(0,sale-window.LUMY_MONEY.fromUSD(500));
  const list=bundleListPriceCents(quantity);
  el.dataset.regularPrice=String(regular);
  el.dataset.salePrice=String(returnActive?returnSale:sale);
  el.textContent=window.LUMY_MONEY.format(returnActive?returnSale:(baseActive?sale:regular));
  const offerTitle=el.closest('.bundle')?.querySelector('[data-bundle-offer] b');
  const offerCopy=el.closest('.bundle')?.querySelector('[data-bundle-offer] small');
  if(offerTitle)offerTitle.textContent=returnActive?'10-MIN PRICE':'20-MIN PRICE';
  if(offerCopy)offerCopy.innerHTML=''+'<time data-bundle-time>'+display+'</time>';
  const extra=el.closest('.bundle')?.querySelector('[data-mv-extra-saving]');if(extra){extra.hidden=!baseActive;extra.textContent='Extra '+window.LUMY_MONEY.format(bundleExtraCents(quantity))+' off';}
  const crossed=el.closest('.bundle')?.querySelector('.bundle-price s');
  if(crossed)crossed.textContent=window.LUMY_MONEY.format(list);
 });
 const selected=Number(document.querySelector('[name=bundle]:checked')?.value||1);
 if(headlinePrice){
  const regular=bundlePreviewCents(selected,baseActive);
  const cents=returnActive?Math.max(0,bundlePreviewCents(selected,true)-window.LUMY_MONEY.fromUSD(500)):regular;
  headlinePrice.textContent=window.LUMY_MONEY.format(cents);
  const compareEl=document.querySelector('#compare-price'),saveEl=document.querySelector('.save');
  if(compareEl)compareEl.textContent=window.LUMY_MONEY.format(bundleListPriceCents(selected));
  const savingTotal=Math.max(0,bundleListPriceCents(selected)-cents);
  document.querySelectorAll('[data-base-saving]').forEach(el=>el.textContent=window.LUMY_MONEY.format(Math.round(savingTotal/selected)));
  const demandSaving=document.querySelector('.demand-preview [data-base-saving]');
  if(demandSaving)demandSaving.textContent=window.LUMY_MONEY.format(Math.round(savingTotal/selected));
  if(saveEl){saveEl.dataset.extraSaving='';saveEl.textContent='SAVE '+window.LUMY_MONEY.format(savingTotal);}
 }
 if(promoCodeBadge){promoCodeBadge.hidden=!baseActive&&!returnActive;promoCodeBadge.textContent='MERRY20'}
 if(returnDiscountBadge){returnDiscountBadge.hidden=!returnActive;returnDiscountBadge.textContent='EXTRA -'+window.LUMY_MONEY.format(window.LUMY_MONEY.fromUSD(500))+' / ORDER'}
 if(checkoutButton)checkoutButton.href=returnActive?'/discount/'+returnDiscountCode+'?redirect=/checkout':baseActive?'/discount/MERRY20?redirect=/checkout':'/checkout';
 checkoutOfferNotes.forEach(note=>note.textContent=returnActive?'Your extra '+window.LUMY_MONEY.format(window.LUMY_MONEY.fromUSD(500))+' off the entire order will apply once at checkout, alongside your player savings. Shipping is confirmed at checkout.':baseActive?'Your selected player offer will auto-apply at checkout while the 20-minute offer is active. Shipping is confirmed at checkout.':'The 20-minute offer has ended. Shipping is confirmed at checkout.');
 if(!window.MV_OFFERS_READY){
  if(checkoutButton)checkoutButton.href='/checkout';
  checkoutOfferNotes.forEach(note=>note.textContent='Draft offer preview: new discounts are awaiting activation. Checkout currently uses the existing store rules.');
 }
 window.MV_PAINT_KITS?.();
 window.LUMY_RETURN_BAR_TICK?.();
 updateOfferSessionState(seconds);
 if(seconds===0)clearExpiredAutoDiscount();
 return seconds;
}
function updateOfferSessionState(seconds){
 const ended=seconds===0;
 offerOverlay.classList.toggle('offer-session-ended',ended);
 offerClaim.disabled=ended;
 offerCopy.disabled=ended;
 offerCopy.setAttribute('aria-label',ended?'Discount session ended':'Copy discount code MERRY20');
 offerOverlay.querySelector('#offer-heading').innerHTML=ended?'This session’s <em>20% offer</em> has ended.':'Your extra <em>20% off</em> is ready.';
 offerOverlay.querySelector('#offer-description').textContent=ended?'This visit’s offer window is closed. The session offer is no longer available.':'Use MERRY20 for 20% off your player. Optional extras keep their displayed prices.';
 offerCopy.querySelector('.offer-copy-hint').textContent=ended?'Session ended':'Copy code';
 if(ended){clearTimeout(offerCopy._copiedTimer);offerCopy.classList.remove('is-copied');offerCopy.querySelector('.offer-copy-status').textContent=''}
 offerClaim.innerHTML=ended?'SESSION ENDED':'GOT IT. USE AT CHECKOUT <span aria-hidden="true">→</span>';
 const trigger=offerBar.querySelector('#offer-open');
 if(trigger){trigger.querySelector('span').textContent=ended?'SESSION ENDED':'✦ EXTRA 20% AT CHECKOUT';trigger.querySelector('strong').textContent=ended?'Offer window closed':'View your code'}
}
function fireConfetti(overlay=offerOverlay){
 if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
 const layer=overlay.querySelector('.offer-confetti');if(!layer)return;layer.replaceChildren();
 const colors=['#c8ef75','#ef567a','#f6cd66','#eef7e0','#73c8bc'];
 for(let i=0;i<32;i++){
  const bit=document.createElement('i'),angle=i*2*Math.PI/32;
  bit.style.setProperty('--x',`${Math.cos(angle)*(110+(i%5)*24)}px`);
  bit.style.setProperty('--y',`${Math.sin(angle)*(90+(i%4)*22)-70}px`);
  bit.style.setProperty('--turn',`${(i%2?1:-1)*(250+i*17)}deg`);
  bit.style.background=colors[i%colors.length];layer.append(bit)
 }
 setTimeout(()=>layer.replaceChildren(),1600);
}
async function copyOfferCode(){
 if(Date.now()>=offerDeadline){updateOfferSessionState(0);return}
 const status=offerCopy.querySelector('.offer-copy-status');
 clearTimeout(offerCopy._copiedTimer);
 try{
  if(navigator.clipboard&&window.isSecureContext)await navigator.clipboard.writeText('MERRY20');
  else{
   const field=document.createElement('textarea');field.value='MERRY20';field.setAttribute('readonly','');field.style.position='fixed';field.style.opacity='0';document.body.append(field);field.select();
   const copied=document.execCommand('copy');field.remove();if(!copied)throw new Error('copy failed');
  }
  status.textContent='Copied';
 }catch{status.textContent='Could not copy';}
 offerCopy.classList.add('is-copied');
 offerCopy._copiedTimer=setTimeout(()=>{status.textContent='';offerCopy.classList.remove('is-copied')},2200);
}
offerCopy.addEventListener('click',copyOfferCode);
function openOffer(auto=false){
 offerTime();
 offerPreviousFocus=document.activeElement;
 offerOverlay.hidden=false;document.body.classList.add('offer-open');offerClose.focus();
 offerStorage.set('merryvinyls-merry20-offer-seen','1');
 if(auto)fireConfetti();
}
function closeOffer(){
 offerOverlay.hidden=true;document.body.classList.remove('offer-open');
 if(offerPreviousFocus&&offerPreviousFocus!==document.body)offerPreviousFocus.focus();
}
offerBar.addEventListener('click',event=>{if(event.target.closest('#offer-open'))openOffer()});offerClose.addEventListener('click',closeOffer);
offerOverlay.addEventListener('click',event=>{if(event.target===offerOverlay)closeOffer()});
document.addEventListener('keydown',event=>{
 if(offerOverlay.hidden)return;
 if(event.key==='Escape'){event.preventDefault();closeOffer()}
 if(event.key==='Tab'){
  const controls=[offerClose,offerCopy,offerClaim].filter(el=>!el.disabled),index=controls.indexOf(document.activeElement);
  if((event.shiftKey&&index===0)||(!event.shiftKey&&index===controls.length-1)){
   event.preventDefault();controls[event.shiftKey?controls.length-1:0].focus();
  }
 }
});
offerClaim.addEventListener('click',()=>{
 if(!offerTime())return;
 closeOffer();
 document.querySelector('#main')?.scrollIntoView({behavior:'smooth'});
});
async function refreshAutoDsSyncedPrice(){
 if(window.LUMY_REFRESH_SOURCES){if(!document.hidden)try{await window.LUMY_REFRESH_SOURCES();offerTime()}catch{}return}

 if(document.hidden)return;
 const handle=window.LUMY_PRODUCT_HANDLE;
 if(!handle)return;
 try{
  const root=window.Shopify?.routes?.root||'/';
  const response=await fetch(root+'products/'+encodeURIComponent(handle)+'.js',{cache:'no-store',credentials:'same-origin'});
  if(!response.ok)return;
  const product=await response.json();
  if(Array.isArray(window.LUMY_VARIANTS))for(const live of product.variants||[]){const known=window.LUMY_VARIANTS.find(v=>String(v.id)===String(live.id));if(known){known.price=Number(live.price);known.available=live.available}}
  const variant=product.variants?.find(item=>String(item.id)===String(window.LUMY_VARIANT_ID));
  const current=Number(variant?.price);
  if(Number.isFinite(current)&&current>0&&current!==Number(window.LUMY_PRICE_CENTS)){
   window.LUMY_PRICE_CENTS=current;
   offerTime();
  }
 }catch{}
}
window.MV_CHECKOUT=async()=>{
 const root=window.Shopify?.routes?.root||'/';
 try{
  const response=await fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store'});
  if(!response.ok)throw Error('cart unavailable');
  let cart=await response.json();
  if(window.LUMY_ENSURE_BUNDLE_GIFTS)cart=await window.LUMY_ENSURE_BUNDLE_GIFTS(cart);
  cart=await synchronizeOfferCart(cart)||cart;
  if(returnOfferIsActive()){await redirectWithReturnDiscount(cart,root);return}
  if(offerTime()===0)await clearExpiredAutoDiscount();
 }catch{}
 markCheckoutDeparture();window.location.assign(root+'checkout');
};
if(checkoutButton)checkoutButton.addEventListener('click',async event=>{
 if(event.defaultPrevented||checkoutButton.getAttribute('aria-disabled')==='true')return;
 event.preventDefault();await window.MV_CHECKOUT();
});
// Entering or explicitly copying the code hands ownership to the customer.
offerCopy.addEventListener('click',()=>offerStorage.set(autoDiscountKey,''));
document.addEventListener('input',event=>{if(/discount/i.test(event.target?.name||event.target?.id||''))offerStorage.set(autoDiscountKey,'')});
offerTime();
setInterval(offerTime,1000);
setInterval(refreshAutoDsSyncedPrice,60000);
refreshAutoDsSyncedPrice();
document.addEventListener('visibilitychange',()=>{if(!document.hidden)refreshAutoDsSyncedPrice()});
document.querySelectorAll('[name=bundle]').forEach(input=>input.addEventListener('change',()=>setTimeout(()=>{offerTime();returnOfferUpdateQuantity()},0)));

/* Checkout-return offer: shown once per tab only after returning from checkout. */
const returnOfferStorage={
 started:'merryvinyls-merry20-return-checkout-started-v6',
 deadline:'merryvinyls-merry20-return-offer-deadline-v6',
 fired:'merryvinyls-merry20-return-offer-fired-v6',
};
const returnOfferDuration=10*60*1000;
const returnOfferHome=!!offerBar&&!/\/checkouts?(?:\/|$)/i.test(window.location.pathname);
const returnOfferOverlay=document.createElement('div');
returnOfferOverlay.className='return-offer-overlay';
returnOfferOverlay.hidden=true;
const returnOfferTarget=Math.max(0,bundlePreviewCents(1,true)-(window.LUMY_MONEY?.fromUSD?window.LUMY_MONEY.fromUSD(500):500));
const returnOfferExtra=window.LUMY_MONEY?.fromUSD?window.LUMY_MONEY.fromUSD(500):500;
const returnOfferUnitPrice=()=>Math.max(0,bundlePreviewCents(1,true)-returnOfferExtra);
const returnOfferCompare=bundleListPriceCents(1);
const returnOfferOldPriceCents=returnOfferCompare;
const returnOfferTotalSaving=Math.max(0,returnOfferCompare-returnOfferTarget);

const returnOfferPrice=window.LUMY_MONEY?.format?window.LUMY_MONEY.format(returnOfferTarget):'$79.99';
const returnOfferOldPrice=window.LUMY_MONEY?.format?window.LUMY_MONEY.format(returnOfferOldPriceCents):'$85.99';
const returnOfferExtraText=window.LUMY_MONEY?.format?window.LUMY_MONEY.format(returnOfferExtra):'$5.00';
const returnOfferTotalSavingText=window.LUMY_MONEY?.format?window.LUMY_MONEY.format(returnOfferTotalSaving):'$15.55';
 const returnOfferTotalSavingPercent=returnOfferCompare>0?(returnOfferTotalSaving/returnOfferCompare*100).toFixed(1)+'%':'0%';
returnOfferOverlay.innerHTML='<section class="return-offer-modal" role="dialog" aria-modal="true" aria-labelledby="return-offer-title" aria-describedby="return-offer-copy"><div class="offer-confetti" aria-hidden="true"></div><div class="return-offer-topline"><span>YOUR EXTRA HOLIDAY OFFER</span><span class="offer-time-boxes return-offer-clock" role="timer" aria-label="Ten-minute offer time remaining"><span><b id="return-offer-top-minutes">10</b><small>mins</small></span><i>:</i><span><b id="return-offer-top-seconds">00</b><small>secs</small></span></span></div><button class="offer-close return-offer-close" type="button" aria-label="Close offer">×</button><div class="return-offer-burst" aria-hidden="true">✦</div><span class="return-offer-kicker">A LITTLE CHRISTMAS THANK-YOU</span><h2 id="return-offer-title">We saved you <em data-return-extra>another '+returnOfferExtraText+'</em></h2><p id="return-offer-copy">Thank you for considering a little Christmas music, made personal. Enjoy an extra '+returnOfferExtraText+' off your entire order, applied once alongside your player savings.</p><div class="return-offer-price-row"><div><small data-return-price-label>PLAYER PRICE, BEFORE EXTRAS</small><strong data-return-price>'+returnOfferPrice+'</strong><s data-return-compare>Was '+returnOfferOldPrice+'</s></div><span class="return-offer-percent"><b data-return-percent>'+returnOfferTotalSavingPercent+'</b><small>SAVED TOTAL</small></span></div><div class="return-offer-ticket"><div><small>TOTAL SAVINGS FROM REGULAR PRICE</small><strong data-return-total-saving>'+returnOfferTotalSavingText+' SAVED</strong></div><div><small>OFFER WINDOW</small><time id="return-offer-ticket-timer">10:00</time></div></div><button class="return-offer-claim" type="button" id="return-offer-claim"><span class="return-offer-claim-copy">Back to checkout at '+returnOfferPrice+'</span><svg class="return-offer-arrow" viewBox="0 0 28 24" aria-hidden="true"><path class="return-arrow-tail" d="M3 12h20"/><path d="m16 5 7 7-7 7"/></svg></button><p class="return-offer-note">Your extra '+returnOfferExtraText+' order discount applies once when you return to checkout.</p><p class="return-offer-status" role="status" aria-live="polite"></p></section>';
if(returnOfferHome)document.body.append(returnOfferOverlay);
const returnOfferClose=returnOfferOverlay.querySelector('.return-offer-close');
const returnOfferClaim=returnOfferOverlay.querySelector('#return-offer-claim');
let returnOfferDeadline=Number(offerStorage.get(returnOfferStorage.deadline))||0;
let returnOfferBarActive=false;
let returnOfferWasActive=false;
let returnOfferTimerInterval=0;
let returnOfferFocus=null;
let returnOfferCart=null;
function returnOfferUpdateQuantity(){
 const mainItems=(returnOfferCart?.items||[]).filter(item=>window.LUMY_IS_MAIN_VARIANT?.(item.variant_id));
 const cartQuantity=mainItems.reduce((sum,item)=>sum+Number(item.quantity||0),0);
 const quantity=cartQuantity||Number(document.querySelector('[name=bundle]:checked')?.value||1);
 const extra=returnOfferExtra;
 const beforeExtra=bundlePreviewCents(quantity,true);
 const previewTotal=Math.max(0,beforeExtra-extra);
 const compare=bundleListPriceCents(quantity);
 const savings=Math.max(0,compare-previewTotal);
 const format=cents=>window.LUMY_MONEY.format(cents);
 returnOfferOverlay.querySelector('[data-return-extra]').textContent='another '+format(extra)+' on your order';
 returnOfferOverlay.querySelector('[data-return-price-label]').textContent=quantity===1?'PLAYER PRICE, BEFORE EXTRAS':'YOUR '+quantity+'-PLAYER PRICE, BEFORE EXTRAS';
 returnOfferOverlay.querySelector('[data-return-price]').textContent=format(previewTotal);
 returnOfferOverlay.querySelector('[data-return-compare]').textContent='Was '+format(compare);
 returnOfferOverlay.querySelector('[data-return-percent]').textContent=compare>0?(savings/compare*100).toFixed(1)+'%':'0%';
 returnOfferOverlay.querySelector('[data-return-total-saving]').textContent=format(savings)+' SAVED';
 returnOfferOverlay.querySelector('.return-offer-claim-copy').textContent='BACK TO CHECKOUT';if(!window.MV_OFFERS_READY)returnOfferOverlay.querySelector('.return-offer-note').textContent='Design preview: the extra $5 offer is awaiting activation. Checkout uses existing store rules.';
 const active=offerStorage.get(returnOfferStorage.fired)==='1'&&Date.now()<returnOfferDeadline;
 const bottom=document.querySelector('#cart-drawer .cart-bottom');
 if(bottom){
  let summary=bottom.querySelector('.return-cart-preview');
  if(!summary){summary=document.createElement('div');summary.className='return-cart-preview';summary.innerHTML='<span data-return-cart-label></span><strong data-return-cart-extra></strong><small>Ten-minute price applies automatically at checkout.</small>';bottom.prepend(summary)}
  summary.hidden=!active||!cartQuantity;
  summary.querySelector('[data-return-cart-label]').textContent='Extra '+format(extra)+' off your entire order';
  summary.querySelector('[data-return-cart-extra]').textContent='−'+format(extra);
 }
}
document.addEventListener('lumyraze:cart-rendered',event=>{returnOfferCart=event.detail?.cart||null;requestAnimationFrame(returnOfferUpdateQuantity)});
async function returnOfferOpen(){
 try{const response=await fetch((window.Shopify?.routes?.root||'/')+'cart.js',{credentials:'same-origin',cache:'no-store'});if(response.ok)returnOfferCart=await response.json()}catch{}

 if(!returnOfferHome||!returnOfferIsActive())return;
 returnOfferFocus=document.activeElement;
 offerStorage.set('merryvinyls-merry20-offer-seen','1');
 offerOverlay.hidden=true;
 document.body.classList.remove('offer-open');
 returnOfferOverlay.hidden=false;
 document.body.classList.add('return-offer-open');
 returnOfferUpdateQuantity();
 returnOfferClose.focus();
 fireConfetti(returnOfferOverlay);
}
function returnOfferCloseModal(){
 returnOfferOverlay.hidden=true;
 document.body.classList.remove('return-offer-open');
 if(returnOfferFocus&&returnOfferFocus.focus)returnOfferFocus.focus();
}
function returnOfferSetBar(){
 returnOfferUpdateQuantity();
 const active=!!offerBar&&offerStorage.get(returnOfferStorage.fired)==='1'&&!/\/checkouts?(?:\/|$)/i.test(window.location.pathname);
 if(active&&!returnOfferBarActive){
  returnOfferBarActive=true;
  offerBar.classList.remove('return-offer-expired');
  offerBar.style.setProperty('--return-progress','0%');
  offerBar.classList.add('top-offer--return');
  offerBar.innerHTML='<button class="return-offer-trigger" id="return-offer-open" type="button" aria-label="Open your ten-minute checkout return offer"><span>✦ EXTRA OFF YOUR ORDER</span><strong>SAVE '+returnOfferExtraText+'</strong><span class="offer-time-boxes return-offer-bar-time" role="timer" aria-label="Checkout offer time remaining"><span><b id="return-offer-bar-minutes">10</b><small>mins</small></span><i>:</i><span><b id="return-offer-bar-seconds">00</b><small>secs</small></span></span></button>';
  offerBar.querySelector('#return-offer-open').addEventListener('click',returnOfferOpen);
 }
 const seconds=window.LUMY_OFFER_STATE?.returnActive?window.LUMY_OFFER_STATE.seconds:Math.max(0,Math.ceil((returnOfferDeadline-Date.now())/1000));
 if(active){
  returnOfferClaim.disabled=seconds===0;
  returnOfferOverlay.classList.toggle('return-offer-expired',seconds===0);
  offerBar.classList.toggle('return-offer-expired',seconds===0);
  if(seconds===0){returnOfferClaim.querySelector('.return-offer-claim-copy').textContent='SESSION ENDED';returnOfferOverlay.querySelector('.return-offer-status').textContent='This ten-minute offer has ended.';}
  const progress=Math.min(1,Math.max(0,1-(returnOfferDeadline-Date.now())/returnOfferDuration));
  offerBar.style.setProperty('--return-progress',(progress*100).toFixed(2)+'%');
  returnOfferOverlay.style.setProperty('--return-progress',(progress*100).toFixed(2)+'%');
  document.body.classList.add('return-offer-active');
  returnOfferWasActive=true;
  const mm=String(Math.floor(seconds/60)).padStart(2,'0'),ss=String(seconds%60).padStart(2,'0');
  for(const id of ['return-offer-bar-minutes','return-offer-top-minutes']){const el=document.getElementById(id);if(el)el.textContent=mm}
  for(const id of ['return-offer-bar-seconds','return-offer-top-seconds']){const el=document.getElementById(id);if(el)el.textContent=ss}
  const display=mm+':'+ss,ticket=returnOfferOverlay.querySelector('#return-offer-ticket-timer');
  if(ticket)ticket.textContent=display;
  const barPrice=offerBar.querySelector('.return-offer-trigger strong');
  if(barPrice)barPrice.textContent='SAVE '+window.LUMY_MONEY.format(returnOfferExtra);
 }else if(returnOfferBarActive){
  returnOfferBarActive=false;
  document.body.classList.remove('return-offer-active');
  offerBar.classList.remove('top-offer--return','return-offer-expired');
  offerBar.style.removeProperty('--return-progress');
  offerBar.innerHTML=defaultOfferBarHTML;
  returnOfferCloseModal();
  offerTime();
  void synchronizeOfferCart();
 }
 if(!active&&returnOfferWasActive&&!returnOfferOverlay.hidden){
  returnOfferClaim.disabled=true;
  returnOfferClaim.querySelector('.return-offer-claim-copy').textContent='SESSION ENDED';
  returnOfferOverlay.classList.add('return-offer-expired');
  for(const id of ['return-offer-top-minutes','return-offer-top-seconds'])returnOfferOverlay.querySelector('#'+id).textContent='00';
  returnOfferOverlay.querySelector('#return-offer-ticket-timer').textContent='00:00';
  returnOfferOverlay.querySelector('.return-offer-status').textContent='This ten-minute preview session has ended.';
 }
}
function claimReturnOffer(){
 if(Date.now()>=returnOfferDeadline){returnOfferSetBar();return}
 const root=window.Shopify?.routes?.root||'/';
 const status=returnOfferOverlay.querySelector('.return-offer-status');
 status.textContent='Applying your ten-minute checkout price…';
 returnOfferClaim.disabled=true;
 fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store'})
  .then(response=>{if(!response.ok)throw new Error('cart unavailable');return response.json()})
  .then(cart=>redirectWithReturnDiscount(cart,root))
  .catch(()=>{returnOfferClaim.disabled=false;status.textContent='Please try the checkout button again to apply your offer.'});
}
returnOfferClose.addEventListener('click',returnOfferCloseModal);
returnOfferOverlay.addEventListener('click',event=>{if(event.target===returnOfferOverlay)returnOfferCloseModal()});
returnOfferClaim.addEventListener('click',claimReturnOffer);
document.addEventListener('keydown',event=>{
 if(returnOfferOverlay.hidden)return;
 if(event.key==='Escape'){event.preventDefault();returnOfferCloseModal()}
 if(event.key==='Tab'){
  const controls=[returnOfferClose,returnOfferClaim].filter(el=>!el.disabled);
  const index=controls.indexOf(document.activeElement);
  if(event.shiftKey&&index===0){event.preventDefault();controls[controls.length-1].focus()}
  else if(!event.shiftKey&&index===controls.length-1){event.preventDefault();controls[0].focus()}
 }
});
function returnOfferMaybeActivate(event){
 if(!returnOfferHome)return;
 const fired=offerStorage.get(returnOfferStorage.fired)==='1';
 const started=Number(offerStorage.get(returnOfferStorage.started))||0;
 const navigationType=performance.getEntriesByType?.('navigation')?.[0]?.type||'';
 const onCheckoutPage=/\/checkouts?(?:\/|$)/i.test(window.location.pathname);
 const checkoutReferrer=/\/checkouts?(?:\/|$)/i.test(document.referrer||'');
 const cameBack=event?.persisted===true||navigationType==='back_forward'||checkoutReferrer;
 const validCheckoutReturn=started>0&&Date.now()-started<2*60*60*1000&&!onCheckoutPage&&cameBack;
 if(!fired&&validCheckoutReturn){
  returnOfferDeadline=Date.now()+returnOfferDuration;
  offerStorage.set(returnOfferStorage.deadline,String(returnOfferDeadline));
  offerStorage.set(returnOfferStorage.fired,'1');
  offerStorage.set(returnOfferStorage.started,'');
  offerStorage.set('merryvinyls-merry20-offer-seen','1');
  returnOfferSetBar();
  returnOfferOpen();
  offerTime();
  void synchronizeOfferCart();
 }else if(returnOfferDeadline>Date.now()&&fired){
  returnOfferSetBar();
  offerTime();
 }else if(started&&Date.now()-started>=2*60*60*1000){
  offerStorage.set(returnOfferStorage.started,'');
 }
}
returnOfferMaybeActivate();
window.addEventListener('pageshow',returnOfferMaybeActivate);
window.LUMY_RETURN_BAR_TICK=returnOfferSetBar;

function maybeOpenWelcomeOffer(){
 if(!returnOfferHome||document.hidden||Date.now()>=offerDeadline)return;
 if(offerStorage.get('merryvinyls-merry20-offer-seen')==='1'||offerStorage.get(returnOfferStorage.fired)==='1')return;
 const started=Number(offerStorage.get(returnOfferStorage.started))||0;
 if(started>0&&Date.now()-started<2*60*60*1000)return;
 if(!returnOfferOverlay.hidden||!offerOverlay.hidden)return;
 openOffer(true);
}
window.setTimeout(maybeOpenWelcomeOffer,800);
document.addEventListener('visibilitychange',()=>{if(!document.hidden)maybeOpenWelcomeOffer()});

/* Hand off the custom Track Order form to the installed 17TRACK widget. */
(function () {
  if (window.location.pathname !== '/apps/17TRACK') return;
  var params = new URLSearchParams(window.location.search);
  var mode = params.get('lookup');
  if (mode !== 'order' && mode !== 'tracking') return;

  function setField(field, value) {
    var setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
    setter.call(field, value);
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
  }

  var attempts = 0;
  var timer = window.setInterval(function () {
    attempts += 1;
    if (attempts > 80) return window.clearInterval(timer);

    if (mode === 'tracking') {
      var trackingTab = document.querySelector('.yq-track-tab-tracking-num');
      var trackingField = document.querySelector('#trackingForm_track_no');
      if (!trackingTab || !trackingField) return;
      trackingTab.click();
      setField(trackingField, params.get('tracking') || '');
      window.clearInterval(timer);
      trackingField.focus();
      return;
    }

    var orderField = document.querySelector('#orderForm_order_no');
    var emailField = document.querySelector('#orderForm_user_email');
    if (!orderField || !emailField) return;
    setField(orderField, params.get('order') || '');
    setField(emailField, params.get('email') || '');
    window.clearInterval(timer);
    orderField.focus();
  }, 100);
})();

async function synchronizeOfferCart(cart=null){
 if(!window.MV_OFFERS_READY){
  if(cart)return cart;
  const response=await fetch((window.Shopify?.routes?.root||'/')+'cart.js',{credentials:'same-origin'});
  return response.ok?response.json():null;
 }

 if(cartOfferPromise)return cartOfferPromise;
 cartOfferApplying=true;
 cartOfferPromise=(async()=>{
  const root=window.Shopify?.routes?.root||'/';
  if(!cart){
   const response=await fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store'});
   if(!response.ok)throw new Error('cart unavailable');
   cart=await response.json();
  }
  const desired=bundleCodeForCart(cart);
  const codes=(cart.discount_codes||[]).map(item=>String(item.code||'')).filter(Boolean);
  const applied=[...codes,...(cart.cart_level_discount_applications||[]).map(item=>item.title),...(cart.items||[]).flatMap(item=>(item.discounts||[]).map(discount=>discount.title||discount.code))].map(value=>String(value||'').trim().toUpperCase());
  const desiredCodes=desired.split(',').filter(Boolean).map(code=>code.toUpperCase());
  const managed=[returnDiscountCode.toUpperCase(),returnBaseDiscountCode,...allBundleDiscountCodes,...Object.values(sourceBundleDiscountCodes).flatMap(Object.values),...legacyOfferDiscountCodes];
  if(desired||offerStorage.get(autoDiscountKey)===String(offerDeadline))managed.unshift('MERRY20');
  const invalid=applied.some(code=>managed.includes(code)&&!desiredCodes.includes(code));
  const missing=desiredCodes.some(code=>!applied.includes(code));
  if(!invalid&&!missing)return cart;
  const keep=codes.filter(code=>!managed.includes(code.toUpperCase()));
  keep.push(...desiredCodes);
  const response=await fetch(root+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:keep.join(',')})});
  if(!response.ok)throw new Error('discount unavailable');
  const updated=await response.json();
  if(desired.split(',').some(code=>['MERRY20','MV2SET11999V1','MV3SET17499V1'].includes(code)))offerStorage.set(autoDiscountKey,String(offerDeadline));
  else offerStorage.set(autoDiscountKey,'');
  document.dispatchEvent(new CustomEvent('lumyraze:cart-offer-applied',{detail:{cart:updated}}));
  const current=bundleCodeForCart(updated);
  if(current!==desired)window.setTimeout(()=>void synchronizeOfferCart(),0);
  return updated;
 })().catch(()=>null).finally(()=>{cartOfferApplying=false;cartOfferPromise=null});
 return cartOfferPromise;
}
document.addEventListener('lumyraze:cart-rendered',event=>{
 if(cartOfferApplying)return;
 void synchronizeOfferCart(event.detail?.cart||null);
});
void synchronizeOfferCart();





document.addEventListener('lumyraze:selection-changed',()=>offerTime());
